import { api } from '../lib/api.ts';
import { toLayout, useDesktop } from './store.ts';

const SAVE_DELAY_MS = 800;

let timer: ReturnType<typeof setTimeout> | undefined;
let lastSent = '';

/** Layout is a convenience: a failed save never interrupts the user, the next change retries it. */
export function saveLayoutNow({ keepalive = false }: { keepalive?: boolean } = {}): Promise<void> {
  clearTimeout(timer);
  timer = undefined;
  const { windows, hydrated } = useDesktop.getState();
  // Before the saved layout arrives, persisting would overwrite it with a half-empty desk.
  if (!hydrated) return Promise.resolve();
  const layout = toLayout(windows);
  const serialized = JSON.stringify(layout);
  if (serialized === lastSent) return Promise.resolve();
  lastSent = serialized;
  return api<void>('/api/desktop/layout', { method: 'PUT', body: layout, keepalive }).catch(() => {
    lastSent = '';
  });
}

/** Debounced save for the moment after a window was moved, resized, opened or closed. */
export function scheduleLayoutSave() {
  clearTimeout(timer);
  timer = setTimeout(() => void saveLayoutNow(), SAVE_DELAY_MS);
}

/** Sends a save that is still waiting for its delay, e.g. when the shell unmounts. */
export function flushPendingLayoutSave() {
  if (timer !== undefined) void saveLayoutNow();
}

/** Forgets what was sent so the next user's layout is never compared with the previous one's. */
export function resetLayoutSync() {
  clearTimeout(timer);
  timer = undefined;
  lastSent = '';
}
